import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCampaignDeviceTypesList,
  hideCampaignDeviceTypesListLoader,
  setCampaignDeviceTypeProfile,
  setCampaignDeviceTypesList,
  setErrorCampaignDeviceTypeProfile,
  showCampaignDeviceTypesListLoader
} from "./actions";
import {
  ADD_CAMPAIGN_DEVICE_TYPES,
  DELETE_CAMPAIGN_DEVICE_TYPES,
  GET_CAMPAIGN_DEVICE_TYPE_PROFILE,
  GET_CAMPAIGN_DEVICE_TYPES_LIST,
  UPDATE_CAMPAIGN_DEVICE_TYPE_PROFILE
} from "./actionTypes";
import {
  deleteCampaignDeviceType,
  getCampaignDeviceType,
  getCampaignDeviceTypeProfile,
  postCampaignDeviceType,
  putCampaignDeviceTypeProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignDeviceTypeList({ payload: data }) {
  try {
    yield put(showCampaignDeviceTypesListLoader());
    let response = yield call(getCampaignDeviceType, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({ ...i, description: i.description === "string" ? "" : i.description }))
    };
    yield put(setCampaignDeviceTypesList(response));
    yield put(hideCampaignDeviceTypesListLoader());
  } catch (error) {
    yield put(hideCampaignDeviceTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignDeviceType({ payload: {deviceType, data } }) {
  try {
    yield put(showCampaignDeviceTypesListLoader());
    yield call(postCampaignDeviceType, {
      name: deviceType.name,
      description: deviceType.description
    });
    yield call(onGetCampaignDeviceTypeList, { payload: data });
    yield put(hideCampaignDeviceTypesListLoader());
    showSuccessMessage("Campaign's device type has been added");
  } catch (error) {
    yield put(hideCampaignDeviceTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteDeviceType({ payload: { id, data } }) {
  try {
    yield put(showCampaignDeviceTypesListLoader());
    yield call(deleteCampaignDeviceType, id);
    yield call(onGetCampaignDeviceTypeList, { payload: data });
    yield put(hideCampaignDeviceTypesListLoader());
    showSuccessMessage("Campaign device type has been deleted");
  } catch (error) {
    yield put(hideCampaignDeviceTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignDeviceTypeProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignDeviceTypeProfile(false));
    let response = yield call(getCampaignDeviceTypeProfile, id);
    yield put(setCampaignDeviceTypeProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorCampaignDeviceTypeProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignDeviceTypeProfile({ payload: {id, deviceType, data } }) {
  try {
    yield put(showCampaignDeviceTypesListLoader());
    yield call(putCampaignDeviceTypeProfile, id, {
      name: deviceType.name,
      description: deviceType.description
    });
    yield call(onGetCampaignDeviceTypeList, { payload: data });
    yield put(hideCampaignDeviceTypesListLoader());
    showSuccessMessage("Campaign device type has been updated");
  } catch (error) {
    yield put(hideCampaignDeviceTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignDeviceTypeListSaga() {
  yield takeEvery(GET_CAMPAIGN_DEVICE_TYPES_LIST, onGetCampaignDeviceTypeList);
  yield takeEvery(DELETE_CAMPAIGN_DEVICE_TYPES, onDeleteDeviceType);
  yield takeEvery(ADD_CAMPAIGN_DEVICE_TYPES, onAddCampaignDeviceType);
  yield takeEvery(GET_CAMPAIGN_DEVICE_TYPE_PROFILE, onGetCampaignDeviceTypeProfile);
  yield takeEvery(UPDATE_CAMPAIGN_DEVICE_TYPE_PROFILE, onUpdateCampaignDeviceTypeProfile);
}

export default campaignDeviceTypeListSaga;
